import React, { useState } from "react";
import "./landing-page.scss";

import { Link } from "react-router-dom";

import { COOKIE_STATUS } from "../../config";
import Navbar from "../../components/Navbar";

export default function StaticLayout({ children }) {
  const [isCookieSet, setCookie] = useState(
    () => sessionStorage.getItem(COOKIE_STATUS) === "true"
  );

  const acceptCookies = () => {
    sessionStorage.setItem(COOKIE_STATUS, "true");
    setCookie(true);
  };

  /* SUB-COMPONENTS */
  const cookiesBanner = (
    <div className="announcement-bar bg-gray-1">
      <div className="container">
        <div className="announcement-bar-text">
          <div className="text-small text-spacer">
            This site uses cookies. Please accept the usage of these cookies.
          </div>
          <Link
            data-w-id="dfcc347b-9488-6802-f907-ea3594cba704"
            to="#"
            className="button button-small button-white w-button"
            onClick={() => acceptCookies()}
          >
            I Understand
          </Link>
        </div>
      </div>
    </div>
  );

  const footer = (
    <div className="footer bg-primary">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">
              <img
                src="/assets/images/byBlackWhite.svg"
                className="footer-byblack-image"
                alt="logo"
              />
              <div className="footer-powerby">
                <div className="footer-powerby-text">Powered by</div>
                <img
                  src="/assets/images/usbc.png"
                  className="footer-powerby-image"
                  alt="usbc"
                />
              </div>
            </Link>
          </div>

          <div>
            <div className="footer-link-title">LEGAL</div>
            <Link to="/page/toc" className="text-white footer-link">
              Terms & Condition
            </Link>
            <Link to="/page/toc" className="text-white footer-link">
              Privacy Policy
            </Link>
          </div>

          <div>
            <div className="footer-link-title">PLATFORM</div>
            <a
              href="https://www.byblack.us/search/"
              className="text-white footer-link"
            >
              Search
            </a>
            <a
              href="https://www.byblack.us/signup"
              className="text-white footer-link"
            >
              List Your Business
            </a>
            <Link to="/login" className="text-white footer-link">
              Certify Your Business
            </Link>
            <a
              href="https://www.byblack.us/refer-a-business"
              className="text-white footer-link"
            >
              Refer a Business
            </a>
          </div>

          <div>
            <div className="footer-link-title">ABOUT</div>
            <Link to="/page/benefits" className="text-white footer-link">
              Benefits
            </Link>
            <Link to="/page/qualifications" className="text-white footer-link">
              Qualifications
            </Link>
            <a
              href="https://www.byblack.us/about-us"
              className="text-white footer-link"
            >
              About Us
            </a>
          </div>

          <div>
            <div className="footer-link-title">HELP</div>
            <a
              href="mailto:certification@byblack.us"
              className="text-white footer-link"
            >
              Contact Us
            </a>
            <Link to="/page/faq" className="text-white footer-link">
              FAQs
            </Link>
          </div>

          <div></div>
        </div>

        <div>
          <div className="social-links footer-social-links">
            <span className="text-small-write">
              Do Not Sell My Personal Information
            </span>
            <a
              href="https://twitter.com/usblackchambers"
              className="button button-round social-button-white w-inline-block"
            >
              <img
                src="/assets/images/landing-page/twitter-light.svg"
                alt=""
                className="social-button-icon"
              />
            </a>
            <a
              href="https://www.facebook.com/usblackchambers/"
              className="button button-round social-button-white w-inline-block"
            >
              <img
                src="/assets/images/landing-page/facebook-light.svg"
                alt=""
                className="social-button-icon"
              />
            </a>
          </div>
        </div>

        {/* <div>
                  <div className="text-small">
                     2021 © Copyright • US Black Chamber of Commerces | ByBlack
                     <a href="https://webflow.com/" target="_blank" className="text-white" />
                  </div>
               </div> */}
      </div>
    </div>
  );

  return (
    <>
      {!isCookieSet && cookiesBanner}
      <Navbar />
      {children}
      {footer}
    </>
  );
}
